import { render, staticRenderFns } from "./OrderBuyConfirmIframe.vue?vue&type=template&id=6a50d151&"
import script from "./OrderBuyConfirmIframe.vue?vue&type=script&lang=ts&"
export * from "./OrderBuyConfirmIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports